export const Addbuyer = [
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Deactive",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
      tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Deactive",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Deactive",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Deactive",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Deactive",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
  {
    Productid: "LBIN256347",
    status: "Active",
    productName: "Nike Shoes",
    productcateogories: "Footwear",
    productHSNCode: "6401",
    tags: ["Electronics", "Software"],
    actions: ["Edit", "View", "Delete"],
  },
];
